import { render, staticRenderFns } from "./search-criterion-item.vue?vue&type=template&id=62312569&"
import script from "./search-criterion-item.vue?vue&type=script&lang=js&"
export * from "./search-criterion-item.vue?vue&type=script&lang=js&"
import style0 from "./search-criterion-item.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports